'use client';
import Button from '@/app/components/ui/Button';
import { useWhatsAppLink } from '@/app/hooks/useWhatsAppLink';

const Header = () => {
  const getWhatsAppLink = useWhatsAppLink();

  const handleWhatsAppClick = () => {
    const link = getWhatsAppLink();
    window.open(link, '_blank');
  }

  return (
    <header className="w-full bg-header-background relative z-50">
      <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative flex items-center justify-between py-4 md:py-6 lg:py-8 px-4 md:px-6 lg:px-8 bg-header-background border-2 border-header-border rounded-2xl shadow-[0px_4px_15px_#888888ff]">
          {/* Logo */}
          <div className="flex-shrink-0">
            <img 
              src="./images/img_group_1707478726.svg" 
              alt="Evolutta Logo" 
              className="w-[34px] h-[22px] sm:w-[51px] sm:h-[33px] md:w-[68px] md:h-[44px]"
            />
          </div>

          {/* CTA Button */}
          <div className="relative z-50">
            <Button
              onClick={handleWhatsAppClick}
              text="QUERO UM RAIO-X OPERACIONAL"
              text_font_size="text-[10px] sm:text-xs md:text-sm"
              text_font_family="Raleway"
              text_font_weight="font-normal"
              text_line_height="leading-base"
              text_text_align="center"
              text_color="text-primary-background"
              fill_background_color="bg-button-primary"
              border_border_radius="rounded-xl"
              padding="py-[8px] px-[12px] sm:py-[10px] sm:px-[20px] sm:pr-[44px]"
              margin="mr-[0px]"
              className="italic flex items-center gap-[6px] sm:gap-[10px] hover:opacity-90 transition-opacity duration-200 group"
            >
              <span className="group-hover:text-[#02020c] transition-colors duration-200 whitespace-nowrap">RAIO-X OPERACIONAL</span>
              <img 
                src="./images/img_group_84.svg" 
                alt="Arrow" 
                className="w-[14px] h-[14px] sm:w-[22px] sm:h-[22px] group-hover:invert transition-all duration-200" 
              />
            </Button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
